import { Group } from 'react-konva';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import TreeNode from './TreeNode';
import { useKonvaImageScale } from 'contexts/ToolDimensionsAndScaleContext';
import FlattenAreaPolygon from 'components/FlattenArea/FlattenAreaPolygon';
import { selectDsmEdits } from 'store/slices/RoofDataSlice/roofSelector';

export default function DsmEditsGroup() {
	const { treeEditingMode } = useSelector((state: RootState) => state.treeSlice.data);
	const baseImageScale = useKonvaImageScale();
	const { trees, flattenArea } = useSelector(selectDsmEdits);

	return (
		<Group
			name='DSM_edits'
			scale={baseImageScale}
			visible={!treeEditingMode}
			listening={false}
		>
			{
				trees.map(t => (<TreeNode key={t.id} tree={t} />))
			}
			<Group name='DSM_edits-flatten-area'>
				{
					flattenArea.map(p => (<FlattenAreaPolygon
						key={p.id}
						polygonId={p.id}
						points={p.coords?.flat()}
						showFill={false}
					/>))
				}
			</Group>

		</Group>
	);
}